module.exports = __webpack_public_path__ + "img/benoit9.0c8fa248.jpg";